<div class="info">
  @if (likesCount) {
    <div class="info__item">
      <app-svg
        icon="white-like"
        [ngClass]="{
          info__item__icon_green: isLiked,
        }"
      ></app-svg>
      <div class="info__item__text" [textContent]="likesCount"></div>
    </div>
  }
  @if (commentCount) {
    <div class="info__item">
      <app-svg icon="white-comment"></app-svg>
      <div class="info__item__text" [textContent]="commentCount"></div>
    </div>
  }
</div>
